// GET DATA UPCOMING EVENT
export const GET_UPCOMING_EVENT_REQUEST = 'GET_UPCOMING_EVENT_REQUEST'
export const GET_UPCOMING_EVENT_FAILED = 'GET_UPCOMING_EVENT_FAILED'
export const GET_UPCOMING_EVENT_SUCCESS = 'GET_UPCOMING_EVENT_SUCCESS'
export const GET_ONLINE_EVENT_SUCCESS = 'GET_ONLINE_EVENT_SUCCESS'
export const GET_STORE_EVENT_SUCCESS = 'GET_STORE_EVENT_SUCCESS'
export const GET_PUBLIC_EVENT_SUCCESS = 'GET_PUBLIC_EVENT_SUCCESS'

